/*
 * @Author: your name
 * @Date: 2020-11-16 11:18:05
 * @LastEditTime: 2022-12-16 17:07:43
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\electronicPatrol\api.js
 */
export const api = {
  queryResPointPage: '/bas/electronicPatrol/queryResPointPage.json', //分页查询巡更点
  addResPoint: '/bas/electronicPatrol/addResPoint.json', //新增巡更点
  queryResPointInfo: '/bas/electronicPatrol/queryResPointInfo.json', //查询巡更点详情
  updateResPoint: '/bas/electronicPatrol/updateResPoint.json', //更新巡更点
  deleteResPoint: '/bas/electronicPatrol/deleteResPoint.json', //删除巡更点
  batchDeleteResPoint: '/bas/electronicPatrol/batchDeleteResPoint.json', //批量删除巡更点详情

  queryBuildingTree: 'cms/building/queryBuildingTree.json', //查询楼栋tree

  getDeviceDetail: '/bms/device/queryDeviceDetails.json', //查询设备信息
  getIndoorDeviceList: '/cms/building/queryDeviceListByBuilding.json', //查询室内设备信息,
  patrolplan: {
    queryAllPoint: '/bas/electronicPatrol/queryResPointList.json', //查询公共点位
    deletePoint: '/bas/electronicPatrol/deleteResPoint.json', //删除公共点位
    updatePoint: '/bas/electronicPatrol/updateResPoint.json', //修改公共点位
    queryPatrolPlan: '/bas/electronicPatrol/queryPatrolPlan.json', //查询巡更计划详情
    deletePatrolTemplate: '/bas/electronicPatrol/deletePatrolTemplate.json', //删除巡更点位模板
    queryPatrolTemplate: '/bas/electronicPatrol/queryPatrolTemplate.json', //查询巡更点位模板详情
    queryPatrolPlanList: '/bas/electronicPatrol/queryPatrolPlanList.json', //查询巡更计划列表
    deletePatrolPlan: '/bas/electronicPatrol/deletePatrolPlan.json', //删除巡更计划
    addPatrolPlan: '/bas/electronicPatrol/addPatrolPlan.json', //新增巡更计划
    updatePatrolPlan: '/bas/electronicPatrol/updatePatrolPlan.json', //修改巡更计划
    updatePlanStatus: '/bas/electronicPatrol/updatePlanStatus.json', //修改巡更状态
    queryPatrolTemplateList:
      '/bas/electronicPatrol/queryPatrolTemplateList.json', //查询巡更点位模板列表
    queryAccountGroup: '/cms/accountGroup/getAccountByAccountGroup.json', //查询账户组与账户关系
    queryRelatGroup: '/cms/account/queryRlatAcctGroup.json', //查询账户关联的账户组
    queryWorkGroupByAreaOrDevice:
      '/cms/workGroup/queryWorkGroupByAreaOrDevice.json', //查询工作组
    updatePatrolTemplate: '/bas/electronicPatrol/updatePatrolTemplate.json' //查询工作组
  },
  queryBuildingList: ' /cms/building/queryBuildingList.json' //查询楼栋楼层list
}
